import { gql } from "@apollo/client";

export const ADD_TRAINER_DETAILS = gql`
  mutation AddTrainerDetails($trainerDetails: AddTrainerDetailsModelInput) {
    addTrainerDetails(trainerDetails: $trainerDetails) {
      hasError
      validationErrors {
        firstName
        lastName
        email
      }
      messages
    }
  }
`;
